import { render, staticRenderFns } from "./DropdownQuickAction.vue?vue&type=template&id=5cc50dec&"
import script from "./DropdownQuickAction.vue?vue&type=script&lang=js&"
export * from "./DropdownQuickAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports